module.exports = __webpack_public_path__ + "resources/img/img-danbiAi-m-en.cff7aa94ea20de39cac99526db976af1.png";